import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Generate another branching set of nodes in an inquiry's context map
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGenerateInquiryContext = packet => {
  return {
    type: 'REQUEST_GENERATE_INQUIRY_CONTEXT',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGenerateInquiryContextSuccess = data => ({
  type: 'RECEIVE_GENERATE_INQUIRY_CONTEXT_SUCCESS',
  data
})

export const receiveGenerateInquiryContextFail = data => ({
  type: 'RECEIVE_GENERATE_INQUIRY_CONTEXT_FAIL',
  data
})

export const tryToGenerateInquiryContext = packet => (dispatch, getState) => {

  dispatch(requestGenerateInquiryContext(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/inquiries/generate-context/' + packet.inquiry_id, {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGenerateInquiryContextSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGenerateInquiryContextFail({errors:e, lastSubmit: packet}));
    })
}
